ckdc.ready(function ($) {
  function slideNext( event ) {
    var $slide = jQuery( event.target ).closest('.click-slide');
    var $next = $slide.next( '.click-slide' );
    if ( ! $next.length ) {
      $next = $slide.siblings().first();
    }
    $slide.hide();
    $next.show();
    event.preventDefault();
    return false;
  }

  ckdc.body.on( 'click', '.click-slide', slideNext );
});
